/* Tracking Scripts */
loadGTMScript('GTM-NKHKC5C')
/* PPC Tracking */
loadScriptCMM("//cdn.rlets.com/capture_configs/479/6a2/42a/b8747a9820f3a4c3c0c81b4.js", null, {async: true});
/* Site-Wide Banner */
deferJQuery(function() {
		headerBannerMultipleColumns([{
		text: "<a style='font-weight:600;' href='/motorized-window-coverings'>Motorized Window Coverings</a>, <a style='font-weight:600;' href='/more-products-services/services/free-estimates'>Free Estimates</a> and <a style='font-weight:600;' href='/more-products-services/services/window-covering-measuring-and-installations'>Window Covering Measuring and Installations</a>.",
		bgColor: "",
		linkColor: "#fff",
		linkHoverColor: "#fff",
		border: "0",
		column_min_width: "50%",
		classname: ""
	},	{
		text: "<strong>NO Sales Tax</strong> on Projects Installed in Delaware!",
		bgColor: "#ffdb77",
		txtColor: "#000",
		linkColor: "#fff",
		linkHoverColor: "#fff",
		border: "0",
		column_min_width: "50%",
		classname: ""
	},	{
		text: "<h2>Request a Consultation <div class='cmm-button-group'><a class='cmm-button cmm-button-hd-colors' href='tel:+14105248909'>(410) 524-8909</a><a class='cmm-button cmm-button-gray-black' data-cmm-ev-label='Banner Email Lead' href='mailto:info@designingwindowsinc.com' target='_blank'>Email Us</a></div></h2><h4>Proudly serving Ocean City, Maryland (MD) and the surrounding areas.</h4>",
		bgColor: "#fafafa",
    	txtColor: "#000",
    	border: "0",
    	padding: "1rem",
		classname: "",
  	}], {
	    padding: "1rem 0 0",
    	border: {
    	border_bottom: "1px solid #ddd",
		},
    	column_min_width: "100%",
    	classname: "cmm-header-banner-fullwidth"
	});
/* Smooth Scrolling */
	cmmSmoothScrollInit();	
});

/* Set max number of reviews to show before slider */
cmmSetNumReviewsStatic(5);
cmmShuffleReviews()


/* Custom Event Tracking */
cmmSetupEventTracking([{selector:'.cmp-navigation__item a[href="/request-consultation"]', action: 'Request Consultation - Menu', event: 'click'}])
if (strPath == "") {
	deferJQuery(function() {
    	headerBannerMultipleColumns([{
			text: "<h2>Stop by our cozy cottage to see our In-Store Displays and meet the Designing Women of Ocean City!</h2>",
			bgColor: "#ff467f",
		}], {
			selector: ".dealer-tiles",
			position: "before"
		});
		cmmHideElements([{
	    	selector: 'h1',
			withText: 'Plantation Shutters, Blinds, Shades and Draperies'
		}, {
	    	selector: 'h1',
			withText: 'Stop by our cozy cottage to see our In-Store Displays and meet the Designing Women of Ocean City!'
		}]);
	});
}

/* ConvertBoost© */
cmmSetupConvertBoost({
    cta_options: [{
        mode: 'modal',
        icon: 'phone',                 
        text: 'Contact Us',		
        text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
        devices: ['desktop', 'laptop'],
        font: {
            family: "AUTO"
        }
      },  {
        mode: 'modal',
        icon: 'phone',
        		
        text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
        devices: ['tablet', 'mobile'],  
    }],
   modal_options: {
    header_text: '<img style="margin-top:10px;max-width:200px;" src="https://assets.hunterdouglas.com/content/dam/dealer-logos/d/designing-windows-237733/64107887.png">',
    header_color: '#ffffff',
    description_text : 'Looking for new window treatments? Designing Windows has a  beautiful selection!',
        font: {
          family: "AUTO"
        },
    buttons: [{
      title: '(410) 524-8909',
      link: 'tel:+14105248909',
      txt_color_hover: '#e26895',
      bg_color: '#e26895',
      class_list: [
        "call-us"
      ],
      icon: 'phone'
    },{
      title: 'VISIT SHOWROOM',
      link: 'https://www.google.com/maps/search/?api=1&query=Designing+Windows+8204+Coastal+Hwy+%2COcean+City%2CMD+21842-2834',
      link_target: '_blank',
      txt_color_hover: '#e26895',
       bg_color: '#e26895',
      class_list: [
        "visit-showroom"
      ],
      icon: 'map-pin'
    }, {
      title: 'REQUEST A CONSULTATION',
      link: '/request-consultation',
      bg_color: '#e26895',
      txt_color_hover: '#e26895',
      class_list: [
        "request-consultation"
      ],
      icon: 'email'
    }],
    footer_text: 'We offer more than just great products; we offer professional service and people with the knowledge you need to put your next project together!',
    footer_color: ''
  }
}).then( _ => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .call-us', action: 'Call (410) 524-8909 - ConvertBoost©', event: 'click'}]); 
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .visit-showroom', action: 'Visit Showroom - ConvertBoost©', event: 'click'}]);  
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .request-consultation', action: 'Request a Consultation - ConvertBoost©', event: 'click'}]);
});